<template>
    <div>
        <h2>Share</h2>
        <div class="c-article__share-btns">
            <div class="inner">
                <a
                    :href="'mailto:?subject=' +
                    encodeURI(communityName + ' article on ' + $root.brand.domain) +
                    '&body=' + encodeURI('I found this great ' +
                    communityName +
                    ' post on ' + $root.brand.domain + ' and I thought you might like to check it out:\n\n' +
                    title + '\n' +
                    url)"
                    @click="closeMenu"
                >
                    <img :src="$cdn('/img/icons/icon-email-share-article.svg')" alt="Share Article via Email">
                </a>
                <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url)" target="_blank" @click="closeMenu">
                    <img :src="$cdn('/img/icons/icon-facebook-article.svg')" alt="Share Article via Facebook">
                </a>
                <a :href="'https://twitter.com/intent/tweet?url=' + encodeURI(url) + '&text=' + encodeURI('Read this great ' + communityName + ' post on ' + $root.brand.domain)" target="_blank" @click="closeMenu">
                    <img :src="$cdn('/img/icons/icon-x-article.svg')" alt="Share Article via X">
                </a>
                <a v-if="$simpleStore.isMobile" :href="'https://wa.me/?text=' + encodeURI(url)" target="_blank" @click="closeMenu">
                    <img :src="$cdn('/img/icons/icon-whatsapp-article.svg')" alt="Share Article via Whatsapp">
                </a>
                <!-- <a href="#0"><img :src="$cdn('/img/icons/icon-facebook-messenger-article.svg')" alt="Share Article via Facebook Messenger"></a>
                <a href="#0"><img :src="$cdn('/img/icons/icon-pinterest-article.svg')" alt="Share Article via Pinterest"></a>
                <a href="#0"><img :src="$cdn('/img/icons/icon-linkedin-article.svg')" alt="Share Article via Linkedin"></a> -->
            </div>
        </div>
    </div>
</template>

<style>
h2 {
    font-size: 20px;
    font-weight: 500;
    padding: 16px 0;
    text-align: center;
}
.c-article__share-btns .inner {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 80%;
}
.c-article__share-btns a {
    border-bottom: none;
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
}
.c-article__share-btns a:hover {
    background: none;
    border-bottom: none;
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
}
.c-article__share-btns {
    max-height: 100px;
    opacity: 1;
    padding-bottom: 16px;
    transition: all 0.4s ease-in;
}
</style>
<script>
export default {
    props: {
        title: String,
        communityName: String,
        show: Boolean
    },
    data() {
        return {
            error: false,
            open: false,
            show: false,
            url: this.$root.brand.share_url + window.location.pathname,
            tweetText: ''
        }
    },
    methods: {
        openPanel() {
            this.open = true;
        },
        closePanel() {
            this.open = false;
        },
        toggle() {
            this.show = !this.show;
        },
        closeMenu() {
            setTimeout(() => {
                this.$root.$emit('bus-post-menu-toggle');
            }, 400);
        }
    }
}
</script>
